// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__M-NRz","author":"Table_author__2_Cn-","authorImage":"Table_authorImage__2kqss","unreadRow":"Table_unreadRow__3ra6o"};